import React, { useState, useEffect } from "react";
import WarfarinCalculator from "./components/WarfarinCalculator";
import GeneralCalculator from "./components/GeneralCalculator";

function App() {
  const [activeTab, setActiveTab] = useState("warfarin");

  return (
    <div className="calculator-container">
      <div className="app-header">
        <h1 className="app-title">Warfarin Dose Calculator</h1>
        <p className="app-subtitle">Professional medical dosing tool</p>
      </div>

      <div className="tab-buttons-container">
        <button
          className={`tab-button ${activeTab === "warfarin" ? "active" : ""}`}
          onClick={() => setActiveTab("warfarin")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
          Warfarin Dose
        </button>
        <button
          className={`tab-button ${activeTab === "general" ? "active" : ""}`}
          onClick={() => setActiveTab("general")}
        >
          <span className="emoji">🔢</span>
          Calculator
        </button>
      </div>

      <div className="content-area">
        {activeTab === "warfarin" ? (
          <WarfarinCalculator />
        ) : (
          <GeneralCalculator />
        )}
      </div>
    </div>
  );
}

export default App;
